import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BrowserOnly from 'components/consumer/BrowserOnly';
const NavModal = t0 => {
  const $ = _c(8);
  const {
    children,
    isOpen: t1
  } = t0;
  const isOpen = t1 === undefined ? false : t1;
  const t2 = !isOpen;
  let t3;
  if ($[0] !== isOpen || $[1] !== t2) {
    t3 = classNames("bg-blackOverlay bottom-0 left-0 pointer-events-none fixed right-0 top-0 z-[1002] transition-opacity duration-500 ease-[ease]", {
      "opacity-0": t2,
      "opacity-100": isOpen
    });
    $[0] = isOpen;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <BrowserOnly><div className={t3} /></BrowserOnly>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== t4) {
    t5 = <>{t4}{children}</>;
    $[5] = children;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
NavModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool
};
export default NavModal;